// Loader.js
import React from "react";

const PageLoader = () => (
  <div className="loader-overlay">
    <div className="loader"></div>
  </div>
);

export default PageLoader;
